import { Component, OnInit, forwardRef } from '@angular/core';
import { NavController, NavParams, ModalController, ToastController, ActionSheetController, AlertController, IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { GrupoGerenciarEsporadicoAddPage } from '../grupo-gerenciar-esporadico-add/grupo-gerenciar-esporadico-add.page';
import { GrupoProvider } from 'src/app/services/grupo/grupo';
import { UserProvider } from 'src/app/services/user/user';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ImagePipe } from 'src/app/pipes/image/image';
import { SemRegistroComponent } from 'src/app/components/sem-registro/sem-registro';
@Component({
  selector: 'app-grupo-gerenciar-esporadico',
  templateUrl: './grupo-gerenciar-esporadico.page.html',
  styleUrls: ['./grupo-gerenciar-esporadico.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ImagePipe,
    TranslateModule,
    SemRegistroComponent
  ],
})
export class GrupoGerenciarEsporadicoPage implements OnInit {
  readOnly: boolean = false;
  visitantes: any = [];
  idReuniao: string;
  idGrupo: string;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public grupoProvider: GrupoProvider,
    public modalCtrl: ModalController,
    public toastCtrl: ToastController,
    public actionSheetCtrl: ActionSheetController,
    public alertCtrl: AlertController,
    private translate: TranslateService,
    public userProvider: UserProvider) {
    this.idReuniao = this.navParams.get('idReuniao');
    this.idGrupo = this.navParams.get('idGrupo');
    this.readOnly = this.navParams.get('readOnly');
    this.grupoProvider.getEsporadicos(this.idReuniao).subscribe((data) => {
      this.visitantes = data;
    });
  }

  ngOnInit() {}

  public closeModal() {
    this.modalCtrl.dismiss();
  }

  proximo() {
    this.modalCtrl.dismiss(true);
  }

  async addVisitantes() {
    const data = { idReuniao: this.idReuniao, idGrupo: this.idGrupo };
    const modalPage = await this.modalCtrl.create({ component: GrupoGerenciarEsporadicoAddPage, componentProps: data });
    modalPage.present();

    const returnModal = (await modalPage.onDidDismiss());
    if (returnModal.data) {
      this.grupoProvider.getEsporadicos(this.idReuniao).subscribe((data) => {
        this.visitantes = data;
      });
    }
  }

  async removerVisitante(visitante: any) {
    const alert = await this.alertCtrl.create({
      cssClass: "alerta-personalizado",
      mode: "ios",
      header: this.translate.instant('Confirma Exclusão?'),
      message: this.translate.instant('Excluir') + ' ' + visitante.nome,
      buttons: [
        {
          text: this.translate.instant('Não'),
          handler: () => { }
        },
        {
          text: this.translate.instant('Sim'),
          handler: () => {
            this.grupoProvider.removerEsporadico(visitante.idEsporadico).subscribe((data) => {
              this.visitantes.splice(this.visitantes.indexOf(visitante), 1);
            });

          }
        }
      ]
    });
    alert.present();
  }

  async detalhes(visitante: any) {
    const buttons = [];

    if (this.userProvider.hasConfig(121)) {
      buttons.push({
        text: this.translate.instant('Remover'),
        handler: () => {
          this.removerVisitante(visitante);
        },
      });

      buttons.push({
        text: this.translate.instant('Fechar'),
      });
    }

    if (buttons.length > 0) {
      const actionSheet = await this.actionSheetCtrl.create({
        header: this.translate.instant('Opções'),
        buttons: buttons
      });

      await actionSheet.present();
    }
  }
}
